import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LinkedInSidebar from '../LinkedInSidebar';
import { Heart, Eye } from "lucide-react";
import axios from "axios";

const TermsPage = ({ currentPage, setCurrentPage, setTitleDescription }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setTitleDescription("Fractofolio - Cookies Policy", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);
  
  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
          
          <div className="lg:col-span-3 space-y-4">
            {/* Hero Post */}
            <div className="linkedin-card">
              <div className="linkedin-card-header">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-blue-800 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-lg">FR</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Cookie Policy</h3>
                    <p className="text-sm text-gray-600">Effective Date:: April 13, 2025</p>
                  </div>
                </div>
              </div>
              
              <div className="linkedin-card-content">
                <div className="text-sm">
                  <p className="font-regular">
                  This Cookie Policy explains how <strong>Fractofolio</strong> {'("we", "us", or "our")'} uses cookies and similar technologies on our website located at <a href="https://fractofolio.com" target="_blank" rel="noopener noreferrer">https://fractofolio.com</a> {'(the "Website")'}. By using our Website, you agree to our use of cookies as described in this policy.
                  </p>
                  <p className="font-regular">
                  If you do not agree with our use of cookies, you should adjust your browser settings accordingly or refrain from using our Website.
                  </p>

                  <p className="mt-3 font-bold">1. What Are Cookies?</p>
                  <p className="font-regular">
                  Cookies are small text files that are stored on your device (computer, tablet, smartphone, etc.) when you visit a website. Cookies are widely used to make websites work more efficiently, as well as to provide information to the owners of the site.
                  </p>
                  <p className="font-regular">
                  Cookies can be <strong>{'"first-party cookies"'}</strong> (set by the website you’re visiting) or <strong>{'"third-party cookies"'}</strong> (set by a domain other than the one you’re visiting).
                  </p>

                  <p className="mt-3 font-bold">2. How We Use Cookies</p>
                  <p className="font-regular">We use cookies to:</p>
                  <ul className="font-regular">
                    <li>Ensure the proper functioning of the Website</li>
                    <li>Enhance user experience and personalization</li>
                    <li>Analyze traffic and user behavior</li>
                    <li>Improve the performance and content of our Website</li>
                    <li>Provide relevant advertising (if applicable)</li>
                  </ul>

                  <p className="mt-3 font-bold">3. Types of Cookies We Use</p>

                  <p className="mt-3 font-bold">a. Strictly Necessary Cookies</p>
                  <p className="font-regular">
                  These cookies are essential for the operation of the Website. They enable core functions such as page navigation, secure access to areas of the site, and form submissions. Without these cookies, the Website cannot function properly.
                  </p>

                  <p className="mt-3 font-bold">b. Performance and Analytics Cookies</p>
                  <p className="font-regular">
                  These cookies collect information about how visitors use our Website, such as which pages are visited most often, and if users get error messages. We use this data to improve how our Website works. These cookies do not collect information that directly identifies you.
                  </p>
                  <p className="font-regular">Examples: Google Analytics, Plausible Analytics (depending on our current setup)</p>

                  <p className="mt-3 font-bold">c. Functionality Cookies</p>
                  <p className="font-regular">
                  These cookies allow the Website to remember choices you make (such as your username, language, or region) and provide enhanced, more personalized features.
                  </p>

                  <p className="mt-3 font-bold">d. Targeting/Advertising Cookies</p>
                  <p className="font-regular">
                  These cookies are used to deliver advertisements that are more relevant to you and your interests. They may also be used to limit the number of times you see an ad and help measure the effectiveness of advertising campaigns. These cookies are typically placed by third-party advertising networks.
                  </p>
                  <p className="font-regular">
                  <strong>Note:</strong> Fractofolio currently does <strong>not</strong> serve advertisements directly. However, we may use third-party services that collect anonymous data for potential future marketing campaigns.
                  </p>

                  <p className="mt-3 font-bold">4. Third-Party Cookies</p>
                  <p className="font-regular">
                  We may allow selected third parties to place cookies through our Website to provide their services, including analytics, performance monitoring, and advertising. These third-party cookies are subject to the respective privacy policies of the service providers.
                  </p>
                  <p className="font-regular">Common third-party providers may include:</p>
                  <ul className="font-regular">
                    <li>Google Analytics</li>
                    <li>Cloudflare</li>
                    <li>Meta Pixel</li>
                    <li>Hotjar or other user behavior tools (if applicable)</li>
                  </ul>

                  <p className="mt-3 font-bold">5. How to Manage Cookies</p>
                  <p className="font-regular">You have several options for managing cookies:</p>

                  <p className="mt-3 font-bold">Through Your Browser Settings:</p>
                  <p className="font-regular">
                  Most web browsers allow you to control cookies through their settings. You can usually find these settings in the “Options” or “Preferences” menu of your browser. You can:
                  </p>
                  <ul className="font-regular">
                    <li>View which cookies are stored on your device</li>
                    <li>Delete all or specific cookies</li>
                    <li>Block cookies from specific websites</li>
                    <li>Block all cookies entirely (may affect site functionality)</li>
                  </ul>

                  <p className="mt-3 font-bold">Opt-Out of Third-Party Tracking:</p>
                  <p className="font-regular">You may also opt out of specific third-party networks through the following platforms:</p>
                  <ul className="font-regular">
                    <li><a href="https://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer">Network Advertising Initiative (NAI)</a></li>
                    <li><a href="https://optout.aboutads.info/" target="_blank" rel="noopener noreferrer">Digital Advertising Alliance (DAA)</a></li>
                    <li><a href="https://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer">Your Online Choices (EU)</a></li>
                  </ul>

                  <p className="mt-3 font-bold">6. Changes to This Cookie Policy</p>
                  <p className="font-regular">
                  We may update this Cookie Policy from time to time to reflect changes in technology, law, or our services. When we do, we will revise the {'"Effective Date"'} at the top of this page. We encourage you to review this policy regularly to stay informed about our use of cookies.
                  </p>

                  <p className="mt-3 font-bold">7. Contact Us</p>
                  <p className="font-regular">
                  If you have any questions about our use of cookies or this Cookie Policy, please contact us at:
                  </p>
                  <p className="font-regular"><strong>Fractofolio</strong><br/>
                  Email: <a href="mailto:support@fractofolio.com">support@fractofolio.com</a><br/>
                  Website: <a href="https://fractofolio.com" target="_blank" rel="noopener noreferrer">https://fractofolio.com</a>
                  </p>

                </div>
              </div>
              
              <div className="linkedin-card-actions">
                {/* <button className="linkedin-action-btn">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                  Like
                </button> */}
                {/* <CommentSection postId="hero" /> */}
                {/* <button className="linkedin-action-btn">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                  </svg>
                  Share
                </button> */}
              </div>
              {/* <CommentSectionExpanded postId="hero" /> */}
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default TermsPage;